export default __webpack_public_path__ + "static/media/Arrow.e0864525.svg";